export enum FORM_HELP {
  threshold = 'You can set an alert for values that exceed a threshold or fall below it.',
  state = 'State field.',
  notification = 'Email List determines the recipients of alert emails. You can enter any combination of individual email addresses and distribution lists.',
  cooldown = 'Cool Down sets the period between consecutive alert notifications. This prevents multiple back-to-back alert notifications for alerts that are being continuously triggered.',
  format = 'Notification Format lets you choose between just email or a combination of email and the same content in JSON format for robots.',
  hoursInDay = 'Allows to restrict the time period when an alert will trigger.'
}
